import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { api, API_BASE } from '@/lib/api';
import { Download } from 'lucide-react';

const DoctorPatient = () => {
  const { userId } = useParams();
  const [data, setData] = useState(null);
  useEffect(() => { api.get(`/doctor/patients/${userId}/timeline`).then(({ data }) => setData(data)); }, [userId]);
  if (!data) return <div className="text-sans_mute">Loading…</div>;
  const u = data.user;

  return (
    <div>
      <Link to="/doctor" className="sans-label hover:text-sans_ink">← Back</Link>
      <h1 className="font-serif text-3xl md:text-4xl text-sans_ink mt-6 tracking-tight">{u.name}</h1>
      <div className="text-sm text-sans_mute mt-1">{u.email}</div>

      <div className="mt-10 grid md:grid-cols-2 gap-6">
        <section>
          <div className="sans-label mb-4">Prakriti assessments</div>
          {data.assessments.length === 0 && <div className="text-sm text-sans_mute">None on record.</div>}
          <div className="space-y-3">
            {data.assessments.map((a) => (
              <div key={a.assessment_id} className="border border-sans_line bg-white p-4">
                <div className="text-xs text-sans_mute">{new Date(a.created_at).toLocaleDateString('en-IN')}</div>
                <div className="font-serif text-lg text-sans_ink mt-1">{a.report ? `${a.report.primary_dosha} / ${a.report.secondary_dosha}` : 'Incomplete'}</div>
                {a.report?.summary && <p className="mt-3 text-sm text-sans_mute leading-relaxed line-clamp-4">{a.report.summary.slice(0, 240)}…</p>}
              </div>
            ))}
          </div>
        </section>

        <section>
          <div className="sans-label mb-4">Appointments</div>
          {data.appointments.length === 0 && <div className="text-sm text-sans_mute">None yet.</div>}
          <div className="space-y-3">
            {data.appointments.map((a) => (
              <Link key={a.appointment_id} to={`/doctor/appointments/${a.appointment_id}`} className="block border border-sans_line bg-white p-4 hover:shadow-[0_8px_32px_rgba(0,0,0,0.04)]">
                <div className="text-xs text-sans_mute">{a.status}</div>
                <div className="text-sm text-sans_ink mt-1">{new Date(a.slot_datetime).toLocaleString('en-IN', { dateStyle: 'medium', timeStyle: 'short' })}</div>
                {a.reason && <div className="text-xs text-sans_mute mt-2 line-clamp-2">{a.reason}</div>}
              </Link>
            ))}
          </div>
        </section>

        <section>
          <div className="sans-label mb-4">Prescriptions</div>
          {data.prescriptions.length === 0 && <div className="text-sm text-sans_mute">None yet.</div>}
          <div className="space-y-3">
            {data.prescriptions.map((r) => (
              <div key={r.prescription_id} className="border border-sans_line bg-white p-4">
                <div className="flex justify-between items-start">
                  <div>
                    <div className="text-xs text-sans_mute">{new Date(r.created_at).toLocaleDateString('en-IN')}</div>
                    <div className="text-sm text-sans_ink mt-1">{r.items?.length || 0} formulation{r.items?.length !== 1 ? 's' : ''}</div>
                  </div>
                  <a href={`${API_BASE}/doctor/prescriptions/${r.prescription_id}/pdf`} target="_blank" rel="noreferrer" className="text-sans_ink hover:opacity-70" aria-label="Download">
                    <Download className="w-4 h-4" strokeWidth={1.5} />
                  </a>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section>
          <div className="sans-label mb-4">Orders</div>
          {data.orders.length === 0 && <div className="text-sm text-sans_mute">None yet.</div>}
          <div className="space-y-3">
            {data.orders.map((o) => (
              <div key={o.order_id} className="border border-sans_line bg-white p-4">
                <div className="flex justify-between">
                  <div className="text-xs text-sans_mute">{new Date(o.created_at).toLocaleDateString('en-IN')}</div>
                  <div className="text-xs text-sans_mute">{o.status}</div>
                </div>
                <div className="text-sm text-sans_ink mt-1">₹{o.total} · {o.items?.length} items</div>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};

export default DoctorPatient;
